import { render, staticRenderFns } from "./approveDtl.vue?vue&type=template&id=2afb2858&scoped=true&"
import script from "./approveDtl.vue?vue&type=script&lang=js&"
export * from "./approveDtl.vue?vue&type=script&lang=js&"
import style0 from "./approveDtl.vue?vue&type=style&index=0&id=2afb2858&prod&lang=scss&scoped=true&"
import style1 from "./approveDtl.vue?vue&type=style&index=1&id=2afb2858&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb2858",
  null
  
)

export default component.exports